"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "m18.33.49-4.757 7.13h4.81L5.005 23.908l5.14-12.033H5.422L11.84.598l.06-.107zM6.155 11.448h4.637l-4.22 9.878L17.478 8.048h-4.705l.222-.333L17.531.918H12.15z"
}), 'EnergyFocus');
